// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2jtoV","visuallyhidden":"mFeUi","hide-text":"_2ud-Q","center":"_3rur8","noprint":"_3esQv","root":"_2HgRA","caption":"_1tfK_","fullcaption":"_2ucMr","captionButton":"iqMdJ","image":"_2f2ch"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-gallery/styles/image/default.scss
 ** module id = 1002
 ** module chunks = 2
 **/